<script setup>
import {computed} from "vue";

const props = defineProps({
  book: Object
});

const siteUrl = document.querySelector('meta[name="site-url"]').content;

// book.thumbnail の拡張子直前を _small に置換したURLを返す
const bookThumbnail = computed(() => {
  // そもそも拡張子があるか判定を兼ねて取得
  const match = props.book.thumbnail.match(/^(.*)(\.[^.]*)$/);

  // 拡張子がない場合はそのまま返す
  if (!match) {
    return props.book.thumbnail;
  }

  // 拡張子を一旦変数に格納
  const extension = match[2];

  // 既に _thumbnail がついている場合はそのまま返す
  if (props.book.thumbnail.endsWith('_thumbnail'+extension)) {
    return props.book.thumbnail;
  }

  // 既に _small がついている場合は _thumbnail に置換して返す
  if (props.book.thumbnail.endsWith('_small'+extension)) {
    return props.book.thumbnail.replace('_small'+extension, '_thumbnail'+extension);
  }

  // 既に _middle がついている場合は _thumbnail に置換して返す
  if (props.book.thumbnail.endsWith('_middle'+extension)) {
    return props.book.thumbnail.replace('_middle'+extension, '_thumbnail'+extension);
  }

  // 既に _big がついている場合は _thumbnail に置換して返す
  if (props.book.thumbnail.endsWith('_big'+extension)) {
    return props.book.thumbnail.replace('_big'+extension, '_thumbnail'+extension);
  }
  // それ以外の場合は拡張子の前に _thumbnail を挿入して返す
  return match[1] + '_thumbnail' + extension;
});
</script>

<template>
  <li class="lyMb8">
    <div class="lyVerticalStartBreak lyFlexItemBreakBan lyPd8 pBackColorWhite pBorderRadius2px">
      <div class="lyHorizontal lyHorizontalRev lyW100">
        <div class="lyPd8 lyW100">
          <p class="pFont14 lyMb8">
            <a
              :href="siteUrl+'book/'+book.id"
              class="pFontBold pFontBlack"
            >{{book.title}}</a>
          </p>
          <dl class="lyMb8 pFont14">
            <div
              v-for="author in book.authors"
              :key="author.id"
              class="lyHorizontal lyMb6"
            >
              <dt class="lyShrinkNone pFontMedium lyW70px">{{author.pivot.position === '' ? '著者名' : author.pivot.position}}</dt>
              <dd>
                <div class="lyHorizontal">
                  <p class="lyW24px lyMr8 lyShrinkNone lyOverFlewHidden pBorderRadiusEllipse">
                    <img
                      :src="author.thumbnail !== '' && author.thumbnail !== null ? siteUrl+'public_image/'+author.thumbnail+'?size=writer' : siteUrl+'images/author/authorDefault@1x.png'"
                      :alt="author.name"
                      loading="lazy"
                    >
                  </p>
                  <p class="pFont14">
                    <a
                      :href="siteUrl+'author/'+author.id"
                      class="pFontMedium"
                    >{{author.name}}</a>
                  </p>
                </div>
              </dd>
            </div>
            <div class="lyHorizontal lyMb6">
              <dt class="pFontMedium lyW70px">出版社</dt>
              <dd>{{book.publisher}}</dd>
            </div>
          </dl>
        </div>
        <p class="lyShrinkNone lyPd8">
          <a
            :href="siteUrl+'book/'+book.id"
            class="lyBlock pImageDropShadow lyImageFitContain"
            style="max-width: 120px;"
          >
            <img
              :src="siteUrl+'public_image/'+bookThumbnail"
              :alt="book.title+'のサムネイル'"
              loading="lazy"
              style="width:100px"
            >
          </a>
        </p>
      </div>
    </div>
  </li>
</template>
